<template>
  <div>
    <br>
    <footer class="gpt-footer bg-grey-light text-grey-dark py-2">
        <div class="container">
            © Administration du Cadastre et de la Topographie 2022
        </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>
